import React, { useEffect, useMemo, useState } from "react";
import BookingsApi from "../state/bookings-api";
import { configStore } from "../state/CommonState";
import { loader } from "../util/loader";
import { ADD_ON_OPTIONS, containerTypeList } from "../StaticData";
import download_icon from "../assets/images/download_icon.png";
import { AgCustomFile } from "../components/AgFile";
import ReactTablePagination from "../components/ag-table/ReactTablePagination";
import * as XLSX from 'xlsx';
import Utils from "../util/Utils"

const PlanningPage = ({ search, keyword, searchCallback, tab, refreshAlert, shipmentType, openContainerPopup }) => {
    const [data, setData] = useState([]);
    const [expandedGroup, setExpandedGroup] = useState(null);
    const [selectedAddons, setSelectedAddons] = useState({});
    const [planRemarks, setPlanRemarks] = useState({});
    const [selectedBookings, setSelectedBookings] = useState({});
    const [stuffing_cutoff, setStuffing_cutoff] = useState({});
    const [pol_container_number, setPol_container_number] = useState({});
    const [mblNumber, setMblNumber] = useState({});
    const [voyage, setVoyage] = useState({});
    const [carrier, setCarrier] = useState({});
    const [containerType, setContainerType] = useState({});
    const [vessel, setVessel] = useState({});
    const [updloadPopup, setUpdloadPopup] = useState(null);
    const [agentSeal, setAgentSeal] = useState({});
    const [customsSeal, setCustomsSeal] = useState({});
    const [validationCalled, setValidationCalled] = useState(false)
    const [popupGroup, setPopupGroup] = useState(null);
    const [uploadedPhotos, setUploadedPhotos] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [consoleId, setConsoleId] = useState({})
    const [refreshAlert2, setRefreshAlert2] = useState({})
    const paginatedData = useMemo(() => {
        if (!Array.isArray(data)) return [];
        return data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    }, [data, currentPage, itemsPerPage]);


    useEffect(() => {
        if ((search && keyword.length > 0) || (keyword.length === 0)) {
            loader.show()
            const fetchData = async () => {
                try {
                    setExpandedGroup(null)
                    let data = {
                        tab: tab,
                        shipmentType: shipmentType,
                        ...(keyword.length > 0 && { keyword: keyword.trim() }),
                    }
                    BookingsApi.getBookingsForConsole(data, (result) => {
                        setData(result || []);
                        setCurrentPage(1);
                        loader.hide()
                    });
                } catch (error) {
                    loader.hide()
                    configStore.modalMessage(error.message);
                }
            };
            setValidationCalled(false)
            setSelectedAddons({});
            setPlanRemarks({});
            setSelectedBookings({});
            setStuffing_cutoff({});
            setPol_container_number({});
            setMblNumber({});
            setVoyage({});
            setCarrier({})
            setContainerType({});
            setConsoleId({});
            setVessel({});
            setAgentSeal({});
            setCustomsSeal({});
            setUploadedPhotos({});

            fetchData();
        }
        searchCallback()
    }, [search, keyword, tab, refreshAlert, refreshAlert2, shipmentType]);
    const cellStyle = { padding: "6px", borderBottom: "1px solid #ccc", minWidth: "150px" };

    const getStatusTransitions = (currentTab) => {
        switch (currentTab) {
            case "To be Planned":
                return [{ label: "Planned ->", status: "Planned", color: '#28a745' }];
            case "Planned":
                return [
                    { label: "<- Planning", status: "To be Planned", color: '#ffc107' },
                    { label: "Confirmation ->", status: "Confirmation", color: '#28a745' },
                ];
            case "Confirmation":
                return [
                    { label: "<- Planning", status: "To be Planned", color: '#ffc107' },
                    { label: "Stuffed ->", status: "Stuffed", color: '#28a745' },
                ];
            case "Stuffed":
                return [];
            default:
                return [];
        }
    };


    const toggleGroup = (index) => {
        setExpandedGroup(expandedGroup === index ? null : index);
        if (expandedGroup !== index) {
            const group = paginatedData[index];

            if (shipmentType === "LCL") {
                setStuffing_cutoff(prev => ({ ...prev, [index]: group.stuffing_cutoff || "" }));
                setPol_container_number(prev => ({ ...prev, [index]: group.pol_container_number || "" }));
                setContainerType(prev => ({ ...prev, [index]: group.containerType || "" }));
                setMblNumber(prev => ({ ...prev, [index]: group.mblNumber || "" }));
                setVessel(prev => ({ ...prev, [index]: group.vessel || "" }));
                setVoyage(prev => ({ ...prev, [index]: group.voyage || "" }));
                setCarrier(prev => ({ ...prev, [index]: group.carrier || "" }));
                setConsoleId(prev => ({ ...prev, [index]: group.consoleId || "" }));
            } else {
                const selectedContainer = group.containerList?.[0];
                if (selectedContainer) {
                    setStuffing_cutoff(prev => ({ ...prev, [index]: selectedContainer.stuffing_cutoff || "" }));
                    setPol_container_number(prev => ({ ...prev, [index]: selectedContainer.pol_container_number || "" }));
                    setContainerType(prev => ({ ...prev, [index]: selectedContainer.containerType || "" }));
                    setMblNumber(prev => ({ ...prev, [index]: selectedContainer.mblNumber || "" }));
                    setVessel(prev => ({ ...prev, [index]: selectedContainer.vessel || "" }));
                    setVoyage(prev => ({ ...prev, [index]: selectedContainer.voyage || "" }));
                    setCarrier(prev => ({ ...prev, [index]: selectedContainer.carrier || "" }));
                    setConsoleId(prev => ({ ...prev, [index]: selectedContainer._id || "" }));
                }
            }
        }
    };

    const handleFclMove = async (group, newStatus) => {
        try {
            loader.show();
            let container = {
                containerStatus: newStatus === 'Stuffed' ? newStatus : 'Stuffing In-Progress',
                _id: group._id,
                carrier: group.carrier,
                mblNumber: group.mblNumber,
                containerList: group.containerList,
                vessel: group.vessel,
                voyage: group.voyage,
                agentSeal: group.agentSeal,
                agentAddress: group.agentAddress,
                customsSeal: group.customsSeal,
                stuffing_cutoff: group.stuffing_cutoff,
                agentName: group.agentName,
            }

            if (newStatus === "Stuffed") {
                const requiredFields = ["stuffing_cutoff", "mblNumber", "voyage", "agentName", "agentAddress", 'carrier', 'vessel'];

                for (const field of requiredFields) {
                    if (!container[field]) {
                        configStore.setModalMessage(`All container details are required before stuffing`);
                        return;
                    }
                }

                const invalidContainer = container.containerList.find(
                    (c) => !c.container_number || !c.container_types || !c.agentSeal || !c.customsSeal
                );

                if (invalidContainer) {
                    configStore.setModalMessage("All containers must have their respective data.");
                    return;
                }
            }
            let postDetails = {
                bookingId: group._id,
                planningStatus: newStatus,
                containerStatus: container.containerStatus
            };

            await BookingsApi.updatePlanningStatus(postDetails);
            setRefreshAlert2(refreshAlert2 + 1)


        } catch (err) {
            console.error(err);
            configStore.setModalMessage("Failed to move booking");
        } finally {
            loader.hide();
        }

    }


    const handleMoveBooking = async (bookingId, newStatus, source, index, selectedContainer, remarks) => {
        try {
            loader.show();

            if (!isConfirmationDataValid(index, selectedContainer) && newStatus === 'Confirmation') {
                setValidationCalled(true);
                configStore.setModalMessage("Please fill all required stuffing details properly.");
                return;
            } else if (newStatus === 'Stuffed' && selectedContainer.containerStatus !== 'Stuffing In-Progress') {
                configStore.setModalMessage(`Please mark container ${selectedContainer._id} as Stuffing In Progress.`);
                return;

            } else if (!isStuffingDataValid(index) && newStatus === 'Stuffed') {
                setValidationCalled(true);
                configStore.setModalMessage("Please fill all required stuffing details properly.");
                return;
            } else if (!isPlannedDataValid(index) && newStatus === 'Planned') {
                setValidationCalled(true);
                configStore.setModalMessage("Please fill all required stuffing details properly.");
                return;
            }

            let postDetails = {
                bookingId,
                planningStatus: newStatus,
                planRemarks: planRemarks[bookingId] || remarks,
                source,
                shipmentType,
            };

            if (newStatus === 'Stuffed') {
                postDetails = {
                    ...postDetails,
                };
            } else if (newStatus === 'Confirmation') {
                postDetails = {
                    ...postDetails,
                    addOns: selectedAddons[bookingId] || [],
                    stuffing_cutoff: stuffing_cutoff[index] || "",
                    pol_container_number: pol_container_number[index] || "",
                    containerType: containerType[index] || "",
                    mblNumber: mblNumber[index] || "",
                    vessel: vessel[index] || "",
                    voyage: voyage[index] || "",
                    carrier: carrier[index] || "",
                };
            } else if (newStatus === 'image') {
                postDetails.photos = uploadedPhotos || []
            } else {
                postDetails = {
                    ...postDetails,
                    stuffing_cutoff: newStatus === 'Planned' ? stuffing_cutoff[index] || "" : null,
                    pol_container_number: newStatus === 'Planned' ? pol_container_number[index] || "" : null,
                    containerType: newStatus === 'Planned' ? containerType[index] || "" : null,
                    mblNumber: newStatus === 'Planned' ? mblNumber[index] || "" : null,
                    vessel: newStatus === 'Planned' ? vessel[index] || "" : null,
                    voyage: newStatus === 'Planned' ? voyage[index] || "" : null,
                    carrier: newStatus === 'Planned' ? carrier[index] || "" : null,
                    consoleId: newStatus === 'Planned' ? consoleId[index] : null,
                    source: newStatus === 'Planned' ? source || "" : null
                };
            }
            await BookingsApi.updatePlanningStatus(postDetails);
            setRefreshAlert2(refreshAlert2+1)


        } catch (err) {
            console.error(err);
            configStore.setModalMessage("Failed to move booking");
        } finally {
            loader.hide();
        }
    };


    const isPlannedDataValid = (index) => {
        if (tab !== "To be Planned") return true;

        return (
            consoleId[index]
        );
    };


    const isStuffingDataValid = (index) => {
        if (tab !== "Planned") return true;

        return (
            stuffing_cutoff[index] &&
            pol_container_number[index].length === 9 &&
            /^[A-Z]{4}[0-9]{7}$/.test(pol_container_number[index]) &&
            containerType[index] &&
            mblNumber[index].trim().length > 0 &&
            vessel[index].trim().length > 0 &&
            voyage[index].trim().length > 0 &&
            carrier[index].trim().length > 0
        );
    };

    const isConfirmationDataValid = (index) => {
        if (tab !== "Stuffed") return true;

        return (
            agentSeal[index] &&
            customsSeal[index] &&
            uploadedPhotos &&
            uploadedPhotos.length > 0
        );

    };
    const deletePhoto = (idxToRemove) => {
        setUploadedPhotos(prev => prev.filter((_, idx) => idx !== idxToRemove));
    };


    const calculateTotals = (group, index) => {
        const groupKey = group.pol + index;
        let totalTgw = 0;
        let totalCbm = 0;
        let totalNum = 0;


        (group.ids || []).forEach((booking) => {
            if (selectedBookings[groupKey]?.includes(booking._id)) {
                totalTgw += Number(booking.tgw) || 0;
                totalCbm += Number(booking.cbm) || 0;
                totalNum += Number(booking.tnp) || 0;
            }
        });

        return {
            totalTgw: totalTgw?.toFixed(2),
            totalCbm: totalCbm?.toFixed(2),
            totalNum: totalNum
        };
    };

    const downloadTemp = (consoleId) => {
        BookingsApi.downloadStuffingSheet(consoleId);
    };



    return (
        <div style={{ padding: "1rem", overflowX: "auto" }}>
            <table style={{ width: "100%", minWidth: "1000px", tableLayout: 'fixed', borderCollapse: "separate", borderSpacing: "0 8px" }}>
                <colgroup>
                    {tab !== 'Stuffed' && <col style={{ width: "180px" }} />}
                    {shipmentType === 'LCL' && <col style={{ width: "180px", padding: "8px" }} />}
                    {shipmentType === 'FCL' && <col style={{ width: "100px", padding: "8px" }} />}
                    <col style={{ width: "180px", padding: "8px" }} />
                    <col style={{ width: "140px", padding: "8px" }} />
                    {/* <col style={{ width: "140px", padding: "8px" }} /> */}
                    <col style={{ width: "180px", padding: "8px" }} />
                    {shipmentType === 'LCL' && <col style={{ width: "100px", padding: "8px" }} />}
                    {shipmentType === 'LCL' && <col style={{ width: "100px", padding: "8px" }} />}
                    {(tab === 'Confirmation' || tab === 'Planned' || tab === 'Stuffed') && (
                        <>
                            {(shipmentType !== 'FCL' || tab !== 'To be Planned') && <col style={{ width: "180px" }} />}
                            {shipmentType === 'LCL' && <col style={{ width: "180px" }} />}
                            {shipmentType === 'LCL' && <col style={{ width: "180px" }} />}
                            <col style={{ width: "180px" }} />
                            <col style={{ width: "180px" }} />
                            <col style={{ width: "180px" }} />
                           {shipmentType === 'FCL' && tab === 'Stuffed' && <col style={{ width: "180px" }} />}
                            <col style={{ width: "180px" }} />
                        </>
                    )}
                    {/* {(tab === 'Planned' || tab === 'Confirmation' || tab === 'Stuffed') && <col style={{ width: "180px" }} />} */}
                    {(tab === 'Planned' || tab === 'Confirmation' || tab === 'Stuffed') && <col style={{ width: "180px" }} />}
                </colgroup>
                <thead>
                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                        {tab !== 'Stuffed' && <th>Move</th>}
                        {shipmentType === 'LCL' ? <th>Container Tag</th> : <th>Edit / View</th>}
                        {shipmentType === 'FCL' && <th>Booking No</th>}
                        <th>Origin</th>
                        <th>Destination</th>
                        {/* <th>Carting ID</th> */}
                        {shipmentType === 'LCL' ? <th>Bookings</th> : <th>Carting</th>}
                        {shipmentType === 'LCL' && <th>Total CBM</th>}
                        {shipmentType === 'LCL' && <th>Net Weight</th>}
                        {(tab === 'Confirmation' || tab === 'Planned' || tab === 'Stuffed') && (
                            <>
                                <th>Stuffing Cut off</th>
                                {shipmentType === 'LCL' && <th>Container #</th>}
                                {shipmentType === 'LCL' && <th>Container Type</th>}
                                <th>MBL #</th>
                                <th>Vessel</th>
                                <th>Voyage</th>
                                <th>Carrier</th>
                            </>
                        )}
                         {(tab === 'Stuffed') && <th style={cellStyle}>Photos</th>}
                        {/* {(tab === 'Planned' || tab === 'Confirmation' || tab === 'Stuffed') && <> <th>Container Info</th> </>} */}
                        {shipmentType === 'LCL' && (tab === 'Planned' || tab === 'Confirmation' || tab === 'Stuffed') && <th>Download</th>}
                    </tr>
                </thead>
                {paginatedData.length > 0 ? (
                    <tbody>
                        {paginatedData.map((group, index) => (
                            <React.Fragment key={`group-${index}`}>
                                <tr style={{ borderBottom: "1px solid #eee" }}>
                                    {tab !== 'Stuffed' && (
                                        <td>
                                            <div style={{ gap: "6px", width: "100%" }}>
                                                {getStatusTransitions(tab).map(t => {
                                                    const groupKey = group.pol + index;
                                                    const selectedIds = selectedBookings[groupKey] || [];
                                                    const allSelected = (group.ids?.length > 0 && group.ids.every(b => selectedIds.includes(b._id)) || shipmentType === 'FCL');
                                                    return (

                                                        <button
                                                            key={t.status}
                                                            style={{
                                                                padding: "5px 6px",
                                                                width: '150px',
                                                                backgroundColor: t.color,
                                                                color: t.color === "#ffc107" ? "#000000" : "#fff",
                                                                border: "none",
                                                                borderRadius: "4px",
                                                                cursor:
                                                                    shipmentType === "FCL" ||
                                                                        (t.status === 'Stuffed' ? allSelected : selectedIds.length > 0)
                                                                        ? "pointer"
                                                                        : "not-allowed",
                                                                opacity:
                                                                    shipmentType === "FCL" ||
                                                                        (t.status === 'Stuffed' ? allSelected : selectedIds.length > 0)
                                                                        ? 1
                                                                        : 0.5,
                                                                fontSize: "0.9rem"
                                                            }}
                                                            disabled={
                                                                shipmentType === "FCL"
                                                                    ? false
                                                                    : t.status === "Stuffed"
                                                                        ? !allSelected
                                                                        : selectedIds.length === 0
                                                            }
                                                            onClick={() => {
                                                                if (t.status === 'Stuffed' && !allSelected) return;
                                                                if (selectedIds.length === 0 && shipmentType !== 'FCL') return;
                                                                shipmentType !== 'FCL' ? selectedIds.forEach(bId => {
                                                                    const booking = group.ids.find(b => b._id === bId);
                                                                    const selectedContainer = group.matchingContainers.find(ct => ct._id === group.consoleId || ct.pol_container_number === group.pol_container_number);
                                                                    if (booking) handleMoveBooking(bId, t.status, booking.source, index, selectedContainer, booking.planRemarks);
                                                                }) :
                                                                    handleFclMove(group, t.status);
                                                                setSelectedBookings(prev => ({ ...prev, [groupKey]: [] }));
                                                            }}
                                                        >
                                                            {t.label}
                                                        </button>

                                                    )
                                                })}
                                            </div>
                                        </td>



                                    )}
                                    <td style={{ paddingRight: "8px" }}>
                                        {shipmentType === "LCL" ? (
                                            tab === "To be Planned" ? (
                                                <select
                                                    value={consoleId[index] || ""}
                                                    onChange={(e) => {
                                                        const selectedId = e.target.value;
                                                        setConsoleId((prev) => ({ ...prev, [index]: selectedId }));

                                                        const selectedContainer = group.matchingContainers.find(
                                                            (ct) => ct._id === selectedId
                                                        );
                                                        if (selectedContainer) {
                                                            setContainerType((prev) => ({ ...prev, [index]: selectedContainer.containerType }));
                                                            setMblNumber((prev) => ({ ...prev, [index]: selectedContainer.mblNumber }));
                                                            setVessel((prev) => ({ ...prev, [index]: selectedContainer.vessel }));
                                                            setVoyage((prev) => ({ ...prev, [index]: selectedContainer.voyage }));
                                                            setCarrier((prev) => ({ ...prev, [index]: selectedContainer.carrier }));
                                                            setAgentSeal((prev) => ({ ...prev, [index]: selectedContainer.agentSeal }));
                                                            setCustomsSeal((prev) => ({ ...prev, [index]: selectedContainer.customsSeal }));
                                                            setStuffing_cutoff((prev) => ({ ...prev, [index]: selectedContainer.stuffing_cutoff }));
                                                            setPol_container_number((prev) => ({ ...prev, [index]: selectedContainer.pol_container_number }));
                                                        }
                                                    }}
                                                    style={{
                                                        border:
                                                            !consoleId[index] && expandedGroup === index && validationCalled
                                                                ? "1px solid red"
                                                                : "1px solid #ccc",
                                                    }}
                                                    className="input is-small"
                                                >
                                                    <option value="">Select</option>
                                                    {group.matchingContainers?.map((ct) => (
                                                        <option key={ct._id} value={ct._id}>
                                                            {ct.pol_container_number || ct._id}
                                                        </option>
                                                    ))}
                                                </select>
                                            ) : (
                                                group.consoleId
                                            )
                                        ) : (
                                            <button
                                                className="button is-info is-small"
                                                disabled={!group.consoleId && shipmentType === 'LCL'}
                                                onClick={() => {
                                                    let container = {
                                                        por: group.pol,
                                                        pod: group.pod,
                                                        fpod: group.fpod,
                                                        pol: group.pol,
                                                        containerStatus: group.containerStatus || 'Stuffing In-Progress',
                                                        _id: group._id,
                                                        carrier: group.carrier,
                                                        mblNumber: group.mblNumber,
                                                        containerList: group.containerList,
                                                        etd_pol: group.etd_pol,
                                                        voyage: group.voyage,
                                                        vessel: group.vessel,
                                                        agentSeal: group.agentSeal,
                                                        customsSeal: group.customsSeal,
                                                        stuffing_cutoff: group.stuffing_cutoff,
                                                        agentName: group.agentName,
                                                        agentAddress: group.agentAddress
                                                    }
                                                    openContainerPopup(container)
                                                }}
                                            >
                                                {tab !== 'Stuffed' ? 'Edit' : 'View'}
                                            </button>
                                        )}
                                    </td>
                                    {shipmentType === 'FCL' && <td>{group.bookingNum}</td>}
                                    <td>{group.pol}</td>
                                    <td>{group.pod}</td>
                                    {/* <td>{group.cartingsheetId || '-'}</td> */}
                                    <td>
                                        <div onClick={() => toggleGroup(index)} style={{ color: "blue", cursor: "pointer" }}>
                                            {expandedGroup === index ? "Hide" : "Linked"} {group.ids?.length} {shipmentType === 'LCL' ? 'Booking' : 'Carting'}(s)
                                        </div>
                                    </td>
                                    {shipmentType === 'LCL' && <td>{group.totalCBM?.toFixed(2)}</td>}
                                    {shipmentType === 'LCL' && <td>{group.totalTGW?.toFixed(2)}</td>}

                                    {(tab === 'Confirmation' || tab === 'Planned' || tab === 'Stuffed') && (
                                        <>
                                            <td style={{ paddingRight: "8px" }}>
                                                <input
                                                    disabled={true}
                                                    type="datetime-local"
                                                    defaultValue={group.stuffing_cutoff}
                                                    value={group.stuffing_cutoff}
                                                    onChange={(e) => setStuffing_cutoff(prev => ({ ...prev, [index]: e.target.value }))}
                                                    style={{
                                                        border: !stuffing_cutoff[index] && validationCalled ? "1px solid red" : "1px solid #ccc"
                                                    }}
                                                />
                                            </td>
                                            {shipmentType === 'LCL' && <td style={{ paddingRight: "8px" }}>
                                                {group.pol_container_number}
                                            </td>}
                                            {shipmentType === 'LCL' && <td style={{ paddingRight: "8px" }}>
                                                {group.containerType}
                                            </td>}
                                            <td style={{ paddingRight: "8px" }}>
                                                {group.mblNumber}
                                            </td>
                                            <td style={{ paddingRight: "8px" }}>
                                                {group.vessel}
                                            </td>
                                            <td>
                                                {group.voyage}
                                            </td>
                                            <td>
                                                {group.carrier}
                                            </td>
                                        </>
                                    )}
                                       {(shipmentType === 'FCL' && tab === 'Stuffed') && (
                                                                                    <td>
                                                                                        <button className="button is-info" onClick={() => {
                                                                                            setUploadedPhotos(group.photos)
                                                                                            setPopupGroup(group);
                                                                                            setUpdloadPopup(index);
                                                                                        }} style={{ padding: '6px 12px' }}>
                                                                                            Photos
                                                                                        </button>
                                                                                    </td>
                                                                                )}

                                    {shipmentType === 'LCL' && (tab === 'Planned' || tab === 'Confirmation' || tab === 'Stuffed') && (
                                        <td>

                                            <span style={{ cursor: 'Pointer' }}
                                                onClick={() => downloadTemp(group.consoleId)}>
                                                <img
                                                    src={download_icon}
                                                    style={{
                                                        width: '20px',
                                                        height: '20px',
                                                    }}
                                                    alt='Download Icon'
                                                />
                                            </span>
                                        </td>
                                    )

                                    }

                                </tr>

                                {expandedGroup === index && (
                                    <tr key={`expand-${index}`}>
                                        <td colSpan={99} style={{ paddingBottom: "20px", backgroundColor: "#fff", width: "100%" }}>
                                            <div style={{
                                                width: "100%",
                                                overflowX: "auto",
                                                marginTop: "8px",
                                                border: "3px solid #ddd",
                                                backgroundColor: "#f9f9f9",
                                                boxShadow: "inset 0 0 5px rgba(0,0,0,0.1)"
                                            }}>
                                                <div style={{
                                                    width: "100%",
                                                    overflowX: "auto",
                                                    marginTop: "8px",
                                                    border: "3px solid #ddd",
                                                    backgroundColor: "#f9f9f9",
                                                    boxShadow: "inset 0 0 5px rgba(0,0,0,0.1)"
                                                }}>
                                                    <table style={{ width: "100%", tableLayout: "auto", borderCollapse: "collapse" }}>
                                                        {shipmentType === 'LCL' ? (
                                                            <>
                                                                {(() => {

                                                                    const { totalTgw, totalCbm, totalNum } = calculateTotals(group, index);

                                                                    return (
                                                                        <thead>
                                                                            <tr style={{ backgroundColor: "#f0f0f0", fontWeight: "bold" }}>
                                                                                <td style={cellStyle}>Selected Totals</td>
                                                                                <td style={cellStyle}>CBM: {totalCbm}</td>
                                                                                <td style={cellStyle}>TGW: {totalTgw}</td>
                                                                                <td style={cellStyle}>Pack Count: {totalNum}</td>
                                                                            </tr>
                                                                        </thead>
                                                                    )
                                                                })()}
                                                                <thead>
                                                                    <tr style={{ position: "sticky", top: 0, backgroundColor: "#eee", zIndex: 2 }}>
                                                                        {tab !== "Stuffed" && <th style={cellStyle}>Move</th>}
                                                                        <th style={cellStyle}>Booking ID</th>
                                                                        <th style={cellStyle}>POR</th>
                                                                        <th style={cellStyle}>Reworking Port</th>
                                                                        <th style={cellStyle}>POD</th>
                                                                        <th style={cellStyle}># of Packages</th>
                                                                        <th style={cellStyle}>CBM</th>
                                                                        <th style={cellStyle}>Shipper</th>
                                                                        <th style={cellStyle}>Consignee</th>
                                                                        <th style={cellStyle}>Customer</th>
                                                                        <th style={cellStyle}>Shipping Bill #</th>
                                                                        <th style={cellStyle}>Shipping Bill Date</th>
                                                                        <th style={cellStyle}>Add-ons</th>
                                                                        <th style={cellStyle}>Commodity</th>
                                                                        <th style={cellStyle}>Carting Date/Time</th>
                                                                        <th style={cellStyle}>ETA @ POL CFS</th>
                                                                        <th style={cellStyle}>Leo Date</th>
                                                                        {( shipmentType === 'FCL' && tab === 'Stuffed') && <th style={cellStyle}>Photos</th>}
                                                                        <th style={cellStyle}>Booking Remarks</th>
                                                                        <th style={cellStyle}>Carting Remarks</th>
                                                                        <th style={cellStyle}>Console Remarks</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody >
                                                                    {group.ids?.slice()
                                                                        .sort((a, b) => {
                                                                            if (a._id < b._id) return -1;
                                                                            if (a._id > b._id) return 1;
                                                                            return 0;
                                                                        }).map((booking) => (
                                                                            <tr
                                                                                key={booking._id}
                                                                                style={booking.hazardous === "Yes" ? { color: "red", fontWeight: "bold" } : {}}
                                                                            >
                                                                                {tab !== "Stuffed" && <td style={cellStyle}>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={(selectedBookings[group.pol + index] || []).includes(booking._id)}
                                                                                        onChange={(e) => {
                                                                                            const groupKey = group.pol + index;
                                                                                            const existing = selectedBookings[groupKey] || [];
                                                                                            if (e.target.checked) {
                                                                                                setSelectedBookings(prev => ({
                                                                                                    ...prev,
                                                                                                    [groupKey]: [...existing, booking._id],
                                                                                                }));
                                                                                            } else {
                                                                                                setSelectedBookings(prev => ({
                                                                                                    ...prev,
                                                                                                    [groupKey]: existing.filter(id => id !== booking._id),
                                                                                                }));
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </td>}
                                                                                <td style={cellStyle}>{booking._id}</td>
                                                                                <td style={cellStyle}>{booking.por}</td>
                                                                                <td style={cellStyle}>{(booking.source === 'reworkingPort' && group.pod) || '-'}</td>
                                                                                <td style={cellStyle}>{booking.destination}</td>
                                                                                <td style={cellStyle}>{booking.tnp || "-"}</td>
                                                                                <td style={cellStyle}>{booking.cbm?.toFixed(2) || "-"}</td>
                                                                                <td style={cellStyle}>{process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE === 'navexel' ? booking.shipperCompany : (booking.shipper || "-")}</td>
                                                                                <td style={cellStyle}>{booking.consignee || "-"}</td>
                                                                                <td style={cellStyle}>{booking.entityName || "-"}</td>
                                                                                <td style={cellStyle}>{booking.exportClearance?.find(
                                                                                    item => item.label === "Shipping Bill Number"
                                                                                )?.value || "-"}</td>
                                                                                <td style={cellStyle}>
                                                                                    {(() => {
                                                                                        const dateStr = booking.exportClearance?.find(
                                                                                            item => item.label === "Shipping Bill Date"
                                                                                        )?.value;

                                                                                        if (!dateStr) return "-";

                                                                                        const dateObj = new Date(dateStr);
                                                                                        return isNaN(dateObj) ? "-" : Utils.ddmmyyyy(dateObj);
                                                                                    })()}
                                                                                </td>


                                                                                <td style={cellStyle}>
                                                                                    {["overHeight", "overlength", "topLoading", "fumigation", "headLoad", "doorLoad", "nonStackable"]
                                                                                        .filter(key => booking[key])
                                                                                        .map(key => key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()))
                                                                                        .join(', ') || 'NA'}
                                                                                </td>
                                                                                <td style={{ ...cellStyle, minWidth: '240px' }}>{booking.commodityType || "-"}</td>
                                                                                <td style={cellStyle}>{booking.cartingDate ? booking.cartingDate : "-"}</td>
                                                                                <td style={cellStyle}>{booking.etaAtPolCfs ? new Date(booking.etaAtPolCfs).toLocaleDateString(("en-GB")) : "-"}</td>
                                                                                <td style={cellStyle}>
                                                                                    {booking.exportClearance?.find(item => item.label === "Let-Export-Order Date")?.value
                                                                                        ? new Date(booking.exportClearance.find(item => item.label === "Let-Export-Order Date").value).toLocaleDateString("en-GB")
                                                                                        : "-"}
                                                                                </td>

                                                                                {( tab === 'Stuffed') && (
                                                                                    <td>
                                                                                        <button className="button is-info" onClick={() => {
                                                                                            setUploadedPhotos(booking.photos)
                                                                                            setPopupGroup(booking);
                                                                                            setUpdloadPopup(index);
                                                                                        }} style={{ padding: '6px 12px' }}>
                                                                                            Photos
                                                                                        </button>
                                                                                    </td>
                                                                                )}
                                                                                <td style={cellStyle}>
                                                                                    {booking.specialInstructions || '-'}</td>
                                                                                <td style={cellStyle}>
                                                                                    {booking.cartingRemarks || '-'}</td>

                                                                                <td style={cellStyle}>
                                                                                    {tab === 'Stuffed' ? (booking.planRemarks ? booking.planRemarks : '-') :
                                                                                        <input
                                                                                            disabled={tab === 'Stuffed'}
                                                                                            type="text"
                                                                                            placeholder="Enter Remarks"
                                                                                            value={planRemarks[booking._id] || booking.planRemarks || ''}
                                                                                            maxLength={50}
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                height: "2.5rem",
                                                                                                // padding: "4px 8px",
                                                                                                fontSize: "0.9rem"
                                                                                            }}
                                                                                            onChange={(e) =>
                                                                                                setPlanRemarks((prev) => ({
                                                                                                    ...prev,
                                                                                                    [booking._id]: e.target.value,
                                                                                                }))
                                                                                            }
                                                                                        />}
                                                                                </td>

                                                                            </tr>
                                                                        ))}

                                                                </tbody></>) :
                                                            <table style={{ width: '100%' }}>
                                                                <thead>
                                                                    <tr
                                                                        style={{
                                                                            position: "sticky",
                                                                            top: 0,
                                                                            backgroundColor: "#eee",
                                                                            zIndex: 2,
                                                                        }}
                                                                    >
                                                                        <th style={cellStyle}>Linked Carting's ID</th>
                                                                        <th style={cellStyle}>Shipping Bill #</th>
                                                                        <th style={cellStyle}>Shipping Bill Date</th>
                                                                        <th style={cellStyle}>POR</th>
                                                                        <th style={cellStyle}>POD</th>
                                                                        <th style={cellStyle}>Shipper</th>
                                                                        <th style={cellStyle}>Consignee</th>
                                                                        <th style={cellStyle}>Customer</th>
                                                                        <th style={cellStyle}>LEO Date</th>
                                                                        <th style={cellStyle}>Commodity</th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    {group.shippingBills?.length > 0 ? (
                                                                        group.shippingBills.map((shippingBill, idx) => (
                                                                            <tr key={idx}>
                                                                                <td style={cellStyle}>{shippingBill.carting || "-"}</td>
                                                                                <td style={cellStyle}>{shippingBill.number || "-"}</td>
                                                                                <td style={cellStyle}>
                                                                                    {shippingBill.date ? Utils.ddmmyyyystring(shippingBill.date) : "-"}
                                                                                </td>
                                                                                <td style={cellStyle}>{group.por || "-"}</td>
                                                                                <td style={cellStyle}>{group.pod || "-"}</td>
                                                                                <td style={cellStyle}>
                                                                                    {process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE === "navexel"
                                                                                        ? group.shipperCompany
                                                                                        : group.shipper || "-"}
                                                                                </td>
                                                                                <td style={cellStyle}>{group.consignee || "-"}</td>
                                                                                <td style={cellStyle}>{group.entityName || "-"}</td>
                                                                                <td style={cellStyle}>{Utils.convertEpochDate(shippingBill.leo) || "-"}</td>
                                                                                <td style={cellStyle}>{group.commodityType || "-"}</td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td style={cellStyle} colSpan={8} align="center">
                                                                                Carting Sheet Not Assigned
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>

                                                            </table>

                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>) : <>No records to display</>}

            </table>
            <ReactTablePagination
                page={paginatedData}
                gotoPage={(pageNumber) => setCurrentPage(pageNumber + 1)}
                previousPage={() => setCurrentPage(p => Math.max(p - 1, 1))}
                nextPage={() => setCurrentPage(p => p + 1)}
                canPreviousPage={currentPage > 1}
                canNextPage={(currentPage * itemsPerPage) < data.length}
                pageOptions={Array.from({ length: Math.ceil(data.length / itemsPerPage) }, (_, i) => i)}
                pageSize={itemsPerPage}
                pageIndex={currentPage - 1}
                pageCount={Math.ceil(data.length / itemsPerPage)}
                setPageSize={(size) => {
                    setItemsPerPage(size);
                    setCurrentPage(1);
                }}
                manualPageSize={true}
                dataLength={data.length}
                rows={paginatedData}
            />


            {
                updloadPopup !== null && (
                    <div style={{
                        position: 'fixed',
                        top: 0, left: 0, right: 0, bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000
                    }}>
                        <div style={{
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '8px',
                            width: '500px',
                            maxHeight: '90vh',
                            overflowY: 'auto'
                        }}>
                            <h3 style={{ fontWeight: 'bold', paddingBottom: '10px' }}>Update Stuffing Details</h3>

                            <div id={`popup-${updloadPopup}`} style={{ marginBottom: '10px' }}>
                                <label>Photos:</label><br />
                                {
                                    <AgCustomFile
                                        source="stuffingphoto"
                                        cat="stuffing"
                                        filetype="image/*"
                                        parent={`popup-${updloadPopup}`}
                                        disabled={tab === 'Stuffed'}
                                        multi={true}
                                        callback={(filename) => {
                                            setUploadedPhotos(prev => Array.isArray(prev) ? [...prev, filename] : [filename]);
                                        }}


                                    />}
                                <div style={{ marginTop: '8px' }}>
                                    {(uploadedPhotos || []).map((file, idx) => {
                                        const fileName = typeof file === 'string' ? file.split('/').pop() : file.name;

                                        const url = typeof file === 'string'
                                            ? process.env.REACT_APP_FILE_SERVER + '/clientfiles/' + fileName
                                            : URL.createObjectURL(file);

                                        return (
                                            <div
                                                key={`${fileName}-${idx}`}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    marginBottom: '8px',
                                                    gap: '10px'
                                                }}
                                            >
                                                <img
                                                    src={url}
                                                    alt={fileName}
                                                    style={{
                                                        width: '50px',
                                                        height: '50px',
                                                        objectFit: 'cover',
                                                        borderRadius: '4px',
                                                        border: '1px solid #ddd'
                                                    }}
                                                />

                                                <a
                                                    href={url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        fontWeight: 'bold',
                                                        color: '#007bff',
                                                        textDecoration: 'underline',
                                                        flex: 1,
                                                        overflowWrap: 'anywhere'
                                                    }}
                                                >
                                                    {fileName}
                                                </a>

                                                <button
                                                    onClick={() => deletePhoto(idx)}
                                                    style={{
                                                        padding: '4px 8px',
                                                        fontSize: '0.75rem',
                                                        color: 'black',
                                                        backgroundColor: '#facc15',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        whiteSpace: 'nowrap'
                                                    }}
                                                >
                                                    Remove
                                                </button>
                                            </div>

                                        );
                                    })}
                                </div>


                            </div>



                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                                <button
                                    className="button is-danger"
                                    onClick={() => {
                                        setUpdloadPopup(null)
                                        setUploadedPhotos([])
                                        setAgentSeal({})
                                        setCustomsSeal({})
                                    }}
                                    style={{ marginRight: '10px', padding: '6px 12px' }}
                                >
                                    Close
                                </button>
                                <button
                                    onClick={() => {
                                        handleMoveBooking(popupGroup._id, 'image')
                                        setUpdloadPopup(null);
                                    }}
                                    style={{ padding: '6px 12px', backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: '#fff', border: 'none', borderRadius: '4px' }}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

        </div >
    );
};

export default PlanningPage;
